export default __webpack_public_path__ + "8a44d3f01bb2870fb94b3d5c188af814.webp";